module.exports = __webpack_public_path__ + "static/media/dash.946d1208.svg";